import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CreateSecretInput_InputAdapter_instance2dkmkaqclcla7 as CreateSecretInput_InputAdapter_instance } from '../type/adapter/CreateSecretInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutation_VariablesAdapterClass;
function CreateSecretMutation_VariablesAdapter() {
  if (CreateSecretMutation_VariablesAdapterClass === VOID) {
    class $ {
      serializeVariables_oaeb6t_k$(writer, value, customScalarAdapters, withDefaultValues) {
        writer.name_i73qwh_k$('input');
        obj(CreateSecretInput_InputAdapter_instance).toJson_h31rt1_k$(writer, customScalarAdapters, value.input_1);
      }
    }
    initMetadataForObject($, 'CreateSecretMutation_VariablesAdapter');
    CreateSecretMutation_VariablesAdapterClass = $;
  }
  return CreateSecretMutation_VariablesAdapterClass;
}
var CreateSecretMutation_VariablesAdapter_instance;
function CreateSecretMutation_VariablesAdapter_getInstance() {
  return CreateSecretMutation_VariablesAdapter_instance;
}
//region block: init
CreateSecretMutation_VariablesAdapter_instance = new (CreateSecretMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  CreateSecretMutation_VariablesAdapter_instance as CreateSecretMutation_VariablesAdapter_instance159o51cg8r2j3,
};
//endregion

//# sourceMappingURL=CreateSecretMutation_VariablesAdapter.mjs.map
